import React, {Component} from 'react';
import Slider from 'react-slick';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import IconButton from 'material-ui/IconButton';
import CircularProgress from 'material-ui/CircularProgress';

import knockoutLogo from "../../../img/ic-nica-logo-large-knockout.svg";
import unverifiedIcon from '../../../img/ic-unverified-location-large.svg';

import "../../../css/LocationDetail.css";
import "../../../css/font-awesome.css";
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"

import styles from "../styles";
import DataStore from "../../../api/DataStore";
import api from "../../../api/api.js";
import FullScreenPhotoGallery from './FullScreenPhotoGallery';

const dataStore = new DataStore();

class DetailTitlePanel extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showDialog: false,
            showFullscreen: false
        }
    }

    onFullScreenClick = () =>{
        // console.log("click")
        var handlers = ["fullscreenchange", "msfullscreenchange", "mozfullscreenchange", "webkitfullscreenchange"];

        for(var handler of handlers){
            this.refs.sliderContainer.addEventListener(handler, this.updateIfExitingFullScreen)
        }
        this.getRequestFullScreenFunc().call(this.refs.sliderContainer);

        //KBM - gonna keep this in here, just in case they say they want a richer photo gallery, since that's really the
        //only feature their customers are paying for
        // this.setState({showFullscreen: true});
    }

    updateIfExitingFullScreen = () => {
        var fullScreenElementNames = ["fullScreenElement", "webkitFullscreenElement", "mozFullScreenElement", "msFullscreenElement"];
        for(var fullScreenElementName of fullScreenElementNames){
            if(document[fullScreenElementName]){
                return
            }
        }
        // basically we've received a full screen change event and no full screen elem, reinitialize this component
        // console.log("calling component update")
        this.forceUpdate();
        this.slider.slickNext();
    }


    getRequestFullScreenFunc(){
        var elem = this.refs.sliderContainer;
        return elem.requestFullscreen || elem.msRequestFullscreen || elem.mozRequestFullScreen || elem.webkitRequestFullscreen;
    }

    getPhotos(){
        let photos, location, size, imageSrc;

        if(this.props.location.photos && this.props.location.photos.length) {
            photos = this.props.location.photos;
        } else {
            location = [this.props.location.address1, this.props.location.city, this.props.location.stateAbbr].join(", ");
            size = [640, 640].join("x");
            imageSrc = "https://maps.googleapis.com/maps/api/streetview?size=" + size + "&location=" + location + "&key=AIzaSyApSGBeZg_jMxvPCItA4b5JJdEvNcUqbyM";
            photos = [imageSrc]
        }
        return photos;
    }

    onClaimLocationClick = () => {
        this.toggleDialog();
    }

    toggleDialog = () =>{
        this.setState(prevState => {
            return {
                showDialog: !prevState.showDialog
            }
        });
    }

    onLogoClick = () => {
        window.open("https://infusioncenter.org", "_target=blank");
    }

    render(){
        let backLabel = this.props.onSelectionCleared ? "BACK TO RESULTS" : "SEARCH";
        let photos = this.getPhotos();

        let sliderSettings = {dots: true, arrows: false, className: "detailPhotosSliderInner",
                             dotsClass: "sliderDots", autoplay: photos.length > 1, infinite: true,
                             initialSlide: 0, autoplaySpeed: 5 * 1000}

        return (
            <div className="detailTitlePanel">

                <div className="detailPhotosSlider" ref="sliderContainer">
                    <Slider {...sliderSettings}i ref={(slider) =>{this.slider=slider}}>
                        {photos.map((photo)=>{
                            return (<div key={photo} style={{
                                backgroundImage: "url('" + photo + "')",
                                backgroundSize: "cover",
                                width: "100%",
                                height: "100%",
                                backgroundRepeat: "no-repeat",
                                backgroundPosition: "50% 50%"
                            }}/>)
                        })}
                    </Slider>
                    <div className="detailPhotosSliderOverlay"></div>
                </div>
                <div className="fullScreenControlContainer container center vertical-center" onClick={this.onFullScreenClick}>
                    <div className="fullScreenControl fa-expand"></div>
                </div>
                <div className="knockoutLogo">
                    <img src={knockoutLogo} onClick={this.onLogoClick} style={{cursor: "pointer"}} alt="nica logo" />
                </div>
                <div className="detailTitlePanelSearchButtonMobile">
                    <TransparentButton label={backLabel} onClick={this.props.onBackClick}/>
                </div>
                <div className="detailTitlePanelContent container flex1">
                    <div className="detailTitlePanelSearchButton">
                        <TransparentButton label={backLabel} onClick={this.props.onBackClick}/>
                    </div>
                    <div className="locationDetailName">{this.props.location.name}</div>
                    {!this.props.location.orgId ?
                        <div className="locationDetailClaimButton" style={{zIndex: 11000, pointerEvents: "all"}}>
                            <div style={{marginRight: "42px"}}>
                                <IconButton
                                    tooltipPosition="top-right"
                                    tooltip="This location has not been claimed and verified by the owner."
                                    tooltipStyles={{
                                        fontSize: "16px",
                                        padding: "10px",
                                    }}>
                                    <img src={unverifiedIcon} alt="unclaimed icon" />
                                </IconButton>
                            </div>
                            <div>
                                <RaisedButton
                                    label="Claim this location"
                                    backgroundColor={"#53c9e8"}
                                    style={{...styles.claimLocationButtonStyle, zIndex: 1000}}
                                    labelStyle={styles.claimLocationButtonLabelStyle}
                                    labelColor={"#ffffff"}
                                    onClick={this.onClaimLocationClick} />
                            </div>
                        </div>
                        :
                        null
                    }
                </div>
                {this.state.showFullscreen ?
                    <FullScreenPhotoGallery
                        images={this.getPhotos()} />
                    :
                    null
                }
                <ClaimLocationDialog
                    open={this.state.showDialog}
                    location={this.props.location}
                    onClose={this.toggleDialog}
                    onSubmit={this.onClaimLocation} />
            </div>
        )
    }
}

class ClaimLocationDialog extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            error: null,
            claimed: false
        }
    }

    openWebSite = () => {
        window.open("https://infusioncenter.org/mycenter/", "_target=blank");
    }

    onClaimLocation = () =>{
        this.setState({loading: true});
        api.claimLocation(this.props.location, () => {
            this.setState({
                claimed: true,
                loading: false
            });
        }, (error) =>{
            this.setState({
                loading: false,
                error: true
            });
        })
    }

    goToLocationManager = () => {
        document.location.href = "/#location-manager";
    }

    getDialogContent() {
        if (dataStore.getUser()) {
            if (!this.state.claimed) {
                return (
                    <div>
                        <div className="claim-location-title">
                            Claim {this.props.location.name}
                        </div>
                        <div className="claim-location-message">
                            <div>
                                By hitting Submit, you are claiming ownership/administration of this Infusion Center Location.
                            </div>
                            <div>
                                A staff member will be in contact with you to verify your identity.
                            </div>
                        </div>
                        <div className="claim-location-dialog-actions">
                            <FlatButton label="Cancel" labelStyle={{color: "#aab4ba"}} style={{marginRight: "15px"}} onTouchTap={this.props.onClose}/>
                            {this.state.loading ?
                                <CircularProgress size={25} thickness={3} />
                                :
                                <RaisedButton label="Submit" labelStyle={{color: "white"}} backgroundColor="#53c9e8" onTouchTap={this.onClaimLocation}/>
                            }
                        </div>
                    </div>
                )
            } else if (!this.state.error) {
                return (
                    <div>
                        <div className="claim-location-title">
                            Success!
                        </div>
                        <div className="claim-location-message">
                            <div>
                                You may now edit the data for this location in the Location Manager.
                            </div>
                        </div>
                        <div className="claim-location-dialog-actions">
                            <FlatButton label="Done" labelStyle={{color: "#aab4ba"}} style={{marginRight: "15px"}} onTouchTap={this.props.onClose}/>
                            <RaisedButton label="Go to location manager" labelStyle={{color: "white"}} secondary={true} onTouchTap={this.goToLocationManager}/>
                        </div>
                    </div>
                )
            } else {
                return (
                    <div>
                        <div className="claim-location-title">
                            An Error Occurred
                        </div>
                        <div className="claim-location-message">
                            <div>
                                Something went wrong. Please try again.
                            </div>
                        </div>
                        <div className="claim-location-dialog-actions">
                            <FlatButton label="OK" labelStyle={{color: "#aab4ba"}} onTouchTap={this.props.onClose}/>
                        </div>
                    </div>
                )
            }
        } else {
            return (
                <div>
                    <div className="claim-location-title">
                        Are you associated with {this.props.location.name}?
                    </div>
                    <div className="claim-location-message">
                        If so, Sign up for a Membership and then Claim this location to edit the data displayed!
                    </div>
                    <div className="claim-location-dialog-actions">
                        <FlatButton label="Cancel" labelStyle={{color: "#aab4ba"}} style={{marginRight: "15px"}} onTouchTap={this.props.onClose}/>
                        <RaisedButton
                            label="visit our web site for more details"
                            labelStyle={{color: "white"}}
                            backgroundColor="#53c9e8"
                            onTouchTap={this.props.onSubmit}
                            style={{marginTop: "20px"}}
                            onClick={this.openWebSite} />
                    </div>
                </div>
            )
        }
    }

    render() {
        return (
            <Dialog
                open={this.props.open}
                modal={false}
                autoScrollBodyContent={true}
                contentStyle={{width: "90%"}}>

                {this.getDialogContent()}

            </Dialog>
        )
    }

}

var TransparentButton = (props) => {
    return (
        <div className="transparentButton" onTouchTap={props.onClick}>
            {props.label}
        </div>
    )
}

export default DetailTitlePanel;



// WEBPACK FOOTER //
// ./src/components/locator/details/DetailTitlePanel.js